/** Uploads one File to /api/uploads and returns { url, path, kind, ... }. */
export async function uploadFile(file, token) {
  const API = process.env.REACT_APP_BACKEND_URL;
  const fd = new FormData();
  fd.append("file", file);
  const res = await fetch(`${API}/api/uploads`, {
    method: "POST",
    headers: token ? { Authorization: `Bearer ${token}` } : {},
    body: fd,
    credentials: "include",
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = Array.isArray(data.detail) ? data.detail[0]?.msg : data.detail;
    throw new Error(err || "Upload failed");
  }
  // Prepend backend URL to the returned path so <img>/<audio>/<video>
  // tags can load it directly.
  const url = `${API}${data.url}`;
  return { ...data, url };
}
